export const DEFAULT_ROUTE = '';
export const EXTERNAL_SR_ONLY_TEXT = '(external)';
export const EXTERNAL_TARGET = '_blank';
export const DEFAULT_LINK_TAB_INDEX = 0;
